import { Box, Image, Stack } from "@chakra-ui/react";
import { useRouter } from "next/router";
import GCPImage from "./GCPImage";

const LogoBtn = ({ isDisabled = false }) => {
  const router = useRouter();
  const { locale } = router;
  const logo = locale === "zh-TW" ? "logo_v_zh-TW.svg" : "logo_v.svg";
  return (
    <Stack
      cursor="pointer"
      direction={{ base: "column", lg: "row" }}
      spacing={{ base: "5px", lg: "12px" }}
      align="center"
      justify="center"
      onClick={() => {
        if (isDisabled) return;
        delete router.query["model"];
        delete router.query["group"];
        delete router.query["order_id"];
        router.push({
          pathname: "/",
          query: router.query,
        });
      }}
    >
      <Box width="110px">
        <GCPImage src={`/images/brand/logos/${logo}`} alt="Logo" />
      </Box>
    </Stack>
  );
};
export default LogoBtn;
